export const CLONE = "CLONE";
export const FILTER_EXTRACT = "FILTER_EXTRACT";
export const NORMALIZATION_COMPLETE = "NORMALIZATION_COMPLETE";

export const NEW_CLIP_COMMIT_TYPES = [
  CLONE,
  FILTER_EXTRACT,
  NORMALIZATION_COMPLETE,
];
